<template>
  <div>
    <svg-icon name="logo-full" class="payment__logo" />
    <h1 class="payment__title">Оплата услуг</h1>
    <strong class="payment__price">3000 <span>₽</span></strong>
  </div>
</template>

<script>
export default {
  name: 'Header'
}
</script>

<style scoped lang="scss">
.payment {
  &__logo {
    width: 178px;
    height: 48px;
    margin-bottom: 48px;

    @include md-and-down {
      display: none;
    }
  }

  &__title {
    font-size: 24px;
    letter-spacing: 0.35px;
    text-transform: uppercase;
    color: $luchmara;
    margin-bottom: 24px;

    @include md-and-down {
      font-size: 20px;
      margin-bottom: 16px;
    }
  }

  &__price {
    font-size: 36px;
    display: flex;
    letter-spacing: 0.35px;
    color: $deepdark;
    align-items: center;
    margin-bottom: 48px;

    span {
      display: block;
      margin-left: 16px;
    }
  }
}
</style>
